import {
  resetCompanyDetails,
  setApideckSession,
  removeEmployee,
  addEmployee,
  updateEmployee,
} from './CompanyReducer';
import {
  fetchCompany,
  addHRIStoCompany,
  fetchCompanyEmployees,
  fetchAllCompanyEmployees,
} from './CompanyThunks';

export const CompanyActions = {
  setApideckSession,
  fetchCompany,
  addHRIStoCompany,
  resetCompanyDetails,
  fetchCompanyEmployees,
  fetchAllCompanyEmployees,
  removeEmployee,
  addEmployee,
  updateEmployee,
};
